import wx from 'weixin-js-sdk'
import { app } from './platform'
import _ from 'underscore'
import { Toast } from 'mint-ui'

const defaultShareAppMessageOptions = {
  title: '苏打优选', // 分享标题
  desc: '', // 分享描述
  link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  imgUrl: '', // 分享图标
  type: '', // 分享类型,music、video或link，不填默认为link
  dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
  success: function () {
    // 用户确认分享后执行的回调函数
    console.log('onMenuShareAppMessage ok')
  },
  cancel: function () {
    // 用户取消分享后执行的回调函数
    console.log('onMenuShareAppMessage cancel')
  },
}

const defaultShareTimelineOptions = {
  title: '苏打优选', // 分享标题
  desc: '', // 分享描述
  link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  imgUrl: '', // 分享图标
  type: '', // 分享类型,music、video或link，不填默认为link
  dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
  success: function () {
    // 用户确认分享后执行的回调函数
    console.log('onMenuShareAppMessage ok')
  },
  cancel: function () {
    // 用户取消分享后执行的回调函数
    console.log('onMenuShareAppMessage cancel')
  },
}

/* 调用方式：
1. sharetofriend(shareOptions)
2. sharetofriend(myShareAppMessageOptions, myShareTimelineOptions)
*/
const sharetofriend = (myShareAppMessageOptions, myShareTimelineOptions) => {
  if (!app.isWechat()) {
    return () => {}
  }

  myShareTimelineOptions = myShareTimelineOptions || myShareAppMessageOptions
  const shareAppMessageOptions = _.assign(defaultShareAppMessageOptions, myShareAppMessageOptions)
  const shareTimelineOptions = _.assign(defaultShareTimelineOptions, myShareTimelineOptions)

  // 分享给朋友
  wx.onMenuShareAppMessage(shareAppMessageOptions)

  // 分享到朋友圈
  wx.onMenuShareTimeline(shareTimelineOptions)
}

export default sharetofriend
